export const TEXT_ICONS_LIGHT_BASE_MAIN = '#323539';
export const TEXT_ICONS_LIGHT_PRIMARY = '#2D146F';
export const BACKGROUND_LIGHT_PRIMARY_MAIN = '#5828C4';
export const STROKE_BASE = '#E5E5E7';
export const TEXT_ICONS_LIGHT_ON_COLOR = '#FFFFFF';
export const BACKGROUND_LIGHT_BASE_MAIN = '#FFFFFF';
export const DOT_COLOR_BLACK_B500 = '#151517';